<template>
  <!--  {{this.items}}-->
  <el-form label-width="100px" class="app">
    <el-form-item label="薪资项目：">
      <el-input v-model="name" style="width: 90%" placeholder="留任奖" disabled/>
    </el-form-item>
    <el-form-item label="备注：">
      <el-input v-model="formData.remark" style="width: 90%" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea"/>
    </el-form-item>
    <h4 style="margin-left: 20px">发放规则：</h4>
    <el-form label-width="120px" class="bordered-container">
      <el-row>
        <el-col :span="12">
          <el-form-item label="金额(元/月)：" required>
            <el-input-number v-model="formData.amount" placeholder="金额" style="width: 100%;" step="100"
                             min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-form-item label="满" required>
              <el-input-number v-model="formData.month_num" placeholder="月份" min="1" style="width: 60%;"
                               controls-position="right"/>
              <el-text>个月发放</el-text>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-top: 7%;text-align: center ">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>
  </el-form>
</template>
<script>
export default {
  name: "RetentionAwards",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      formData: {},
    }
  },

  methods: {

    async saveButton() {
      try {
        const amount = Number(this.formData.amount);
        const monthNum = Number(this.formData.month_num);

        if (isNaN(amount) || amount <= 0) {
          this.$message.error("请填写有效的金额！");
          return;
        }

        if (isNaN(monthNum) || monthNum <= 0) {
          this.$message.error("请填写有效的月份！");
          return;
        }

        let params = {
          formData: this.formData,
          itemId: this.parentData.id
        };

        await this.$http("salaryRuleConfigureService.saveRetentionAwards", params);
        this.$message.success("保存成功！");
        this.$fn.closeWindow();
        this.$fn.search();
      } catch (error) {
        this.$message.error("保存失败，请稍后再试！");
        console.error("保存失败:", error);
      }
    },

    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        this.formData = await this.$http("salaryRuleConfigureService.getRetentionAwards", params);
      }
    }
  },
  created() {
    this.getData();
  }
}
</script>

<style scoped lang="less">

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 30px 10px 10px 5px;
  width: 98%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>